
import O1HD, { services } from "../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SkinExplainPage extends cc.Component {

    @property({type:cc.Node})
    content:cc.Node = null;

    @property({type:cc.Node,displayName:"皮肤图片"})
    skinSp:cc.Node = null;

    @property({type:cc.Label,displayName:"皮肤名字文本"})
    skinNameLb:cc.Label = null;

    @property({type:cc.RichText,displayName:"皮肤描述文本"})
    skinExplainLb:cc.RichText = null;

    @property({type:cc.Node,displayName:"使用按钮"})
    useBtn:cc.Node = null;
    
    // data:SKIN_INTERFACE = null;

    start(){
        this.open();
    }
    
    // setData(data:SKIN_INTERFACE){
    //     this.data = data;
    //     this.updatePage();
    // }

    // updatePage(){
    //     if(!this.data) return;
    //     let name = this.data.name;
    //     let explain = this.data.getExplain;
    //     let isUnlock = getOneSkinIsUnlock(this.data.id);
    //     this.skinNameLb.string = isUnlock ? name : "???";
    //     this.skinExplainLb.string = explain;
    //     if(isUnlock){
    //         this.skinSp.color = cc.color(255,255,255);
    //     }else{
    //         this.skinSp.color = cc.color(0,0,0);
    //     }
    //     this.updateBtn();
    //     this.loadSp();
    // }

    // updateBtn(){
    //     let isUnlock = getOneSkinIsUnlock(this.data.id);
    //     let use:cc.Node = this.useBtn.getChildByName("unlock");
    //     let notUse:cc.Node = this.useBtn.getChildByName("lock");
    //     use.active = isUnlock;
    //     notUse.active = !isUnlock;
    // }

    // loadSp(){
    //     // 加载动画或者图片
    //     if(!this.data) return;
    //     O1HD.getModules().uiControlModule.getGameBundle().load(`Image/SkinSp/${this.data.spPath}`,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
    //         if(err){
    //             console.log("加载图片出错");
    //             return;
    //         }
    //         this.skinSp.getComponent(cc.Sprite).spriteFrame = asset;
    //     });
    // }

    open(){
        this.node.opacity = 0;
        cc.tween(this.node).to(0.25,{opacity:255}).start();
            cc.tween(this.content).delay(0.2).call(()=>{
                // O1HD.getManagers().soundMgr.playSound("tanchuang");
        }).to(0.3,{scale:1},{easing:'backOut'}).start();
    }

    close(){
        if(this.node.isValid){
            cc.tween(this.node).to(0.1,{opacity:0}).call(()=>{
                this.node.destroy();
                this.node.removeFromParent();
            }).start();
        }
    }

    // onBtnConfirm(){
    //     if(!this.data){
    //         this.close();
    //         return;
    //     }
    //     if(getOneSkinIsUnlock(this.data.id)&&services().userSrv.getUserUseSkin()!=this.data.id){
    //         O1HD.getModules().uiControlModule.showMessageBox("使用皮肤成功");
    //         O1HD.getServices().userSrv.setUserUseSkin(this.data.id);
    //         O1HD.getModules().gameHttpModule.setUserSkin(this.data.id);
    //         O1HD.emit("skinitemupdataitem");
    //     }
    //     this.close();
    // }

}
